/** Tetapan -> Perancangan -> Kalendar dan tempoh kes (Fasa 2 P2-2, P19-P20). */
export default {
  calendar: {
    title: 'Kalendar hari bekerja',
    description:
      'Hujung minggu dan cuti umum yang digunakan untuk mengira tempoh dalam hari bekerja. Import tahun baharu apabila diumumkan, dan tambah penutupan anda sendiri di sini.',
    originTenant: 'Disimpan untuk organisasi ini',
    originPack: 'Kalendar lalai (belum disimpan)',
    originNone:
      'Tiada kalendar: tiada tempoh dapat dikira, sama ada dalam hari bekerja atau hari kalendar, sehingga kalendar diimport.',
    revision: 'Semakan {{revision}}',
    coverage: 'Meliputi {{from}} hingga {{to}}',
    timezone: 'Zon waktu: {{zone}}',
    weekends: 'Hujung minggu',
    weekendOpen: '{{days}} mulai {{from}}',
    weekendClosed: '{{days}} dari {{from}} hingga {{to}}',
    holidays: 'Cuti',
    provisional: 'Sementara',
    source: 'Sumber',
    noSource: 'Tiada sumber awam',
    remove: 'Buang',
    removeTitle: 'Buang {{name}} ({{date}})?',
    removeBody:
      'Tempoh yang dikira selepas anda menyimpan akan menganggap {{date}} sebagai hari bekerja. Ini menyimpan semakan baharu kalendar.',
    removeReplacements: 'Hari cuti ganti ini dibuang bersamanya:',
    removeRestore:
      'Borang tambah tidak dapat mencipta semula cuti umum atau hari cuti ganti. Untuk memulihkannya kemudian, import fail kalendar yang mengandunginya; eksport kalendar dahulu untuk menyimpan salinan.',
    removeConfirm: 'Buang cuti',
    removeCancel: 'Batal',
    add: 'Tambah cuti atau penutupan',
    date: 'Tarikh',
    nameMs: 'Nama (Bahasa Melayu)',
    nameEn: 'Nama (Bahasa Inggeris)',
    kind: 'Jenis',
    kindAdhoc: 'Cuti yang diisytiharkan (dengan sumber awam)',
    kindTenant: 'Penutupan kami sendiri',
    sourceUrl: 'URL sumber',
    note: 'Catatan',
    addSubmit: 'Tambah',
    nameRequired: 'Masukkan nama.',
    dateRequired: 'Pilih tarikh dalam liputan kalendar.',
    sourceRequired: 'Cuti yang diisytiharkan memerlukan pautan kepada pengumumannya.',
    import: 'Import fail JSON',
    export: 'Eksport sebagai JSON',
    schema: 'Muat turun format fail (Skema JSON)',
    importFailed: 'Fail itu tidak dapat dibaca sebagai JSON.',
    saved: 'Kalendar disimpan (semakan {{revision}}).',
    saving: 'Menyimpan kalendar…',
    notNewer:
      'Versi kalendar ini yang lebih baharu sudah disimpan (semakan {{revision}}). Muat semula halaman dan cuba lagi.',
    uncovered:
      'Tempoh berjalan tanpa tarikh akhir: {{count}}. Kiraannya melepasi {{to}}; import kalendar yang meliputinya.',
    uncoveredNoCalendar:
      'Tempoh berjalan tanpa tarikh akhir: {{count}}. Tanpa kalendar, tiada satu pun dapat dikira; import kalendar.',
    loadFailed: 'Kalendar tidak dapat dimuatkan.',
  },
  clocks: {
    title: 'Tempoh',
    running: 'Berjalan',
    paused: 'Dijeda',
    stopped: 'Dihentikan',
    expired: 'Tamat',
    due: 'Tamat tempoh {{date}}',
    dueSoon: 'Hampir tamat',
    noDue: 'Tiada tarikh akhir',
    uncovered: 'Belum ada kalendar yang meliputi tempoh ini.',
    workingDays: 'hari bekerja',
    calendarDays: 'hari kalendar',
    extensions: 'Lanjutan: {{count}}',
    pausedFor: 'Masa dijeda: {{days}} hari',
  },
} as const
